import React, { Component } from 'react';
import { withRouter, matchPath } from 'react-router-dom';
import { connect } from 'react-redux';
import Pages from './pages';
import Page from './page';
import TableOfContents from './table-of-contents';
import NewChapter from './new-chapter';
import NewPage from '../editor-components/new-page';
import Contributors from './contributors';
import { fetchBook, fetchChapters, fetchPages } from '../../actions';
import Book from './book';
// import Notebook from '../notebook-components/notebook';
import BookLink from './book-link';
import UserProfile from '../profile-components/user-profile';
import PersonalProfile from '../profile-components/personal-profile';

class Wrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  // display book title to navigate back to TOC on click
  renderHeader = () => {
    const onMyProfile = matchPath(this.props.location.pathname, {
      path: '*/myprofile*',
    });
    const onContrib = matchPath(this.props.location.pathname, {
      path: '*/contributors',
    });
    if (!this.props.match.params.userID && !onMyProfile && !onContrib) {
      return (
        <BookLink className="book-title-header"
          id={`${this.props.currentBook?.title?.toLowerCase().replace(/\s+/g, '').replace(/\+/g, '')}-header`}
          to={`/books/${this.props?.currentBook?.id}/chapters`}
        >
          <p>{this.props?.currentBook?.title}</p>
        </BookLink>
      );
    } else return null;
  }

  // based on path display appropriate component (ie. new page, new chapter ...)
  renderWrapperContent = () => {
    // References: https://stackoverflow.com/questions/42253277/react-router-v4-how-to-get-current-route
    // https://stackoverflow.com/questions/45875415/checking-for-a-specific-url-ending-using-react-router-v4
    const onNewPage = matchPath(this.props.location.pathname, {
      path: '*/newpage',
    });
    const onNewChapter = matchPath(this.props.location.pathname, {
      path: '*/new',
      exact: true,
    });
    const onContrib = matchPath(this.props.location.pathname, {
      path: '*/contributors',
    });
    const onEdit = matchPath(this.props.location.pathname, {
      path: '*/edit',
    });
    const onMyProfile = matchPath(this.props.location.pathname, {
      path: '*/myprofile*',
    });

    if (onNewPage) {
      return <NewPage />;
    } else if (onEdit && this.props.match.params.pageID) {
      return <NewPage />;
    } else if (this.props.match.params.pageID) {
      return <Page key={this.props.match.params.pageID} />;
    } else if (onContrib) {
      return <Contributors />;
    } else if (this.props.match.params.chapterID) {
      return <Pages key={this.props.match.params.chapterID} />;
    } else if (onNewChapter) {
      return <NewChapter />;
    } else if (onMyProfile) {
      return <PersonalProfile />;
    } else if (this.props.match.params.userID) {
      return <UserProfile />;
    } else {
      return <TableOfContents />;
    }
  }

  render() {
    const onContrib = matchPath(this.props.location.pathname, {
      path: '*/contributors',
    });
    // diplay appropriate color based on book
    if (!onContrib && !this.props.match.params.userID && !this.props.match.params.myID) {
      return (
        <div id={`${this.props.currentBook?.title?.toLowerCase().replace(/\s+/g, '').replace(/\+/g, '')}-binding`} className="book-binding">
          <div id={`${this.props.currentBook?.title?.toLowerCase().replace(/\s+/g, '').replace(/\+/g, '')}-shadow`} className="book-parent">
            <div className="page-container">
              <Book>
                {this.renderHeader()}
                {this.renderWrapperContent()}
              </Book>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="page-container">
          <div className="book-parent">
            <Book>
              {this.renderHeader()}
              {this.renderWrapperContent()}
            </Book>
          </div>
        </div>
      );
    }
  }
}

// connects particular parts of redux state to this components props
const mapStateToProps = (state) => (
  {
    currentBook: state.books.current,
    currentChapter: state.chapters.current,
  }
);

// react-redux glue -- outputs Container that know state in props
// also with an optional HOC withRouter
export default withRouter(connect(mapStateToProps, { fetchBook, fetchChapters, fetchPages })(Wrapper));
